import { Container } from '@mui/material';
import Footer from '../../components/Footer/Footer';
import Navbar from '../../components/Navbar/Navbar';
import EmptySpace from '../../components/EmptySpace/EmptySpace';
import SectionTitle from '../../components/SectionTitle/SectionTitle';

function LegalNotices() {
  return (
    <>
      <Navbar />
      <EmptySpace id='start' />
      <EmptySpace />

      <Container>
        <SectionTitle
          overtitle='Last Updated: 21.09.2024'
          title='Legal Notices'
          highlight='for iGlow.bike and iGlow.swiss'
        />
        <div
          dangerouslySetInnerHTML={{
            __html: `<body lang=en-CH style='tab-interval:35.4pt;word-wrap:break-word'>

<div class=WordSection1>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;mso-outline-level:3'><b><span lang=EN-US style='font-size:
13.5pt;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:
FR'>Site Publisher<o:p></o:p></span></b></p>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal'><span lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif;
mso-fareast-font-family:"Times New Roman";mso-font-kerning:0pt;mso-ligatures:
none;mso-ansi-language:EN-US;mso-fareast-language:FR'>The websites <b>iGlow.bike</b>
and <b>iGlow.swiss</b> are published by :<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal'><b><span lang=EN-US style='font-size:12.0pt;font-family:
"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";mso-font-kerning:
0pt;mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:FR'>Company
Name</span></b><span lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif;
mso-fareast-font-family:"Times New Roman";mso-font-kerning:0pt;mso-ligatures:
none;mso-ansi-language:EN-US;mso-fareast-language:FR'>: iGlow Swiss <br>
<b>Mailing Address</b>: BP 590, 1001 Lausanne, Vaud, Switzerland<br>
<b>Publication Director</b>: FGAF<br>
<b>Contact</b>: contact@iglow.bike<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal'><span lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif;
mso-fareast-font-family:"Times New Roman";mso-font-kerning:0pt;mso-ligatures:
none;mso-ansi-language:EN-US;mso-fareast-language:FR'>Detailed information
regarding the company (registration number, VAT, etc.) as well as personal
information about the directors and affiliated entities (B OF W Worldwide Ltd,
iGlow Swiss, FGAF Holding.) remains confidential and may only be disclosed upon
legitimate request, in accordance with data protection laws and security
protocols.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;mso-outline-level:3'><b><span lang=EN-US style='font-size:
13.5pt;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:
FR'>Website Hosting<o:p></o:p></span></b></p>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal'><span lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif;
mso-fareast-font-family:"Times New Roman";mso-font-kerning:0pt;mso-ligatures:
none;mso-ansi-language:EN-US;mso-fareast-language:FR'>The websites <b>iGlow.bike</b>
and <b>iGlow.swiss</b> are hosted by Infomaniak Network SA. For confidentiality
reasons, the full contact details of the host are not published here. For any
inquiries regarding hosting, please contact us directly at contact@iglow.bike.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;mso-outline-level:3'><b><span lang=EN-US style='font-size:
13.5pt;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:
FR'>Intellectual Property<o:p></o:p></span></b></p>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal'><span lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif;
mso-fareast-font-family:"Times New Roman";mso-font-kerning:0pt;mso-ligatures:
none;mso-ansi-language:EN-US;mso-fareast-language:FR'>The content of the
websites <b>iGlow.bike</b> and <b>iGlow.swiss</b>, including but not limited to
text, images, graphics, logos, icons, videos, and software, is protected by
intellectual property laws, including copyright and trademarks.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal'><span lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif;
mso-fareast-font-family:"Times New Roman";mso-font-kerning:0pt;mso-ligatures:
none;mso-ansi-language:EN-US;mso-fareast-language:FR'>Any reproduction,
distribution, modification, adaptation, or exploitation of this content without
prior written permission from iGlow Swiss SA is strictly prohibited and
constitutes infringement, punishable by civil and criminal penalties.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;mso-outline-level:3'><b><span lang=EN-US style='font-size:
13.5pt;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:
FR'>Liability<o:p></o:p></span></b></p>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal'><span lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif;
mso-fareast-font-family:"Times New Roman";mso-font-kerning:0pt;mso-ligatures:
none;mso-ansi-language:EN-US;mso-fareast-language:FR'>iGlow Swiss SA strives to
ensure the accuracy and timeliness of the information published on the websites
<b>iGlow.bike</b> and <b>iGlow.swiss</b>. However, iGlow Swiss SA cannot
guarantee the accuracy, completeness, or currency of the information provided.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal'><span lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif;
mso-fareast-font-family:"Times New Roman";mso-font-kerning:0pt;mso-ligatures:
none;mso-ansi-language:EN-US;mso-fareast-language:FR'>As a result, iGlow Swiss
SA disclaims any responsibility for errors, omissions, or results obtained from
the use of this information. The user is solely responsible for the use of the
information available on the website.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal'><span lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif;
mso-fareast-font-family:"Times New Roman";mso-font-kerning:0pt;mso-ligatures:
none;mso-ansi-language:EN-US;mso-fareast-language:FR'>iGlow Swiss SA cannot be
held liable for any direct or indirect damages resulting from access to or use
of the websites <b>iGlow.bike</b> and <b>iGlow.swiss</b>, including any
technical malfunctions, viruses, or other issues.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal'><span lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif;
mso-fareast-font-family:"Times New Roman";mso-font-kerning:0pt;mso-ligatures:
none;mso-ansi-language:EN-US;mso-fareast-language:FR'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal'><span lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif;
mso-fareast-font-family:"Times New Roman";mso-font-kerning:0pt;mso-ligatures:
none;mso-ansi-language:EN-US;mso-fareast-language:FR'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;mso-outline-level:3'><b><span lang=EN-US style='font-size:
13.5pt;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:
FR'>Protection of Personal Data<o:p></o:p></span></b></p>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal'><span lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif;
mso-fareast-font-family:"Times New Roman";mso-font-kerning:0pt;mso-ligatures:
none;mso-ansi-language:EN-US;mso-fareast-language:FR'>The personal data
collected via the websites <b>iGlow.bike</b> and <b>iGlow.swiss</b> are
processed in accordance with our (URL to Privacy Policy). In compliance with
applicable data protection laws, you have the right to access, rectify, delete,
and port your personal data, as well as the right to object to and restrict the
processing of your data. To exercise these rights, please contact us at
contact@iglow.bike.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;mso-outline-level:3'><b><span lang=EN-US style='font-size:
13.5pt;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:
FR'>Hyperlinks<o:p></o:p></span></b></p>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal'><span lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif;
mso-fareast-font-family:"Times New Roman";mso-font-kerning:0pt;mso-ligatures:
none;mso-ansi-language:EN-US;mso-fareast-language:FR'>The websites <b>iGlow.bike</b>
and <b>iGlow.swiss</b> may contain hyperlinks to third-party websites. iGlow
Swiss SA assumes no responsibility for the content or practices of these
third-party websites. Access to these sites is at the sole discretion and
responsibility of the user.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;mso-outline-level:3'><b><span lang=EN-US style='font-size:
13.5pt;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:
FR'>Governing Law and Jurisdiction<o:p></o:p></span></b></p>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal'><span lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif;
mso-fareast-font-family:"Times New Roman";mso-font-kerning:0pt;mso-ligatures:
none;mso-ansi-language:EN-US;mso-fareast-language:FR'>These legal notices are
governed by Swiss law. Any disputes relating to the interpretation or execution
of these notices will be subject to the exclusive jurisdiction of the courts
located at the headquarters of iGlow Swiss SA, unless otherwise required by law
or regulation.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;mso-outline-level:3'><b><span lang=EN-US style='font-size:
13.5pt;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:
FR'>Contact<o:p></o:p></span></b></p>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal'><span lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif;
mso-fareast-font-family:"Times New Roman";mso-font-kerning:0pt;mso-ligatures:
none;mso-ansi-language:EN-US;mso-fareast-language:FR'>For any questions
regarding these legal notices, you may contact us at the following address:<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal'><span class=SpellE><b><span lang=FR style='font-size:12.0pt;
font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:FR'>iGlow</span></b></span><b><span
lang=FR style='font-size:12.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:
"Times New Roman";mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:
FR'> <span class=SpellE>Swiss</span> </span></b><span lang=FR style='font-size:
12.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:FR'><br>
BP 590, 1001 Lausanne, Vaud, <span class=SpellE>Switzerland</span><br>
<span class=GramE>Email:</span> <span class=SpellE>webmaster@iglow.bike</span><b><o:p></o:p></b></span></p>

<p class=MsoNormal><span lang=FR><o:p>&nbsp;</o:p></span></p>

</div>

</body>`,
          }}
        />
        <EmptySpace />
      </Container>
      <Footer />
    </>
  );
}

export default LegalNotices;
